'use strict';
const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        uri: '',
        storageObjectId: '',
        thumbnailURI: '',
        uploaded: false
    },

    getURI: function() {
        return this.get('uri');
    },

    getStorageObjectId: function() {
        return this.get('storageObjectId');
    },

    getThumbnailURI: function() {
        return this.get('thumbnailURI');
    },

    isUploaded: function() {
        return this.get('uploaded');
    },

    /**
     * 空のデータか否かを表す
     * URI と StorageObjectId がともに null だったら empty と判断する
     */
    isEmpty: function() {
        return !this.getURI() && !this.getStorageObjectId();
    }
});



// WEBPACK FOOTER //
// ./data/domain/value/content/data-source.js